import { useEffect, useRef } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { ROUTE_NAME, ROUTE_PATH } from 'utils/constants/router';
import { useAuth } from 'utils/hooks/useAuth';

const CASES = [
  {
    id: 'questionnaire',
    entry: ({ isAuthenticated, isAuthPending, pathname }) => {
      if (isAuthenticated || isAuthPending) {
        return false;
      }
      return !!matchPath(pathname, {
        path: ROUTE_PATH[ROUTE_NAME.QUESTIONNAIRE],
        exact: true,
      });
    },
    exit: ({ pathname }) => ![ROUTE_PATH[ROUTE_NAME.SIGN_UP], ROUTE_PATH[ROUTE_NAME.QUESTIONNAIRE]].some(
      (path) => matchPath(pathname, {
        path,
        exact: true,
      }),
    ),
    listener: (event) => {
      event.preventDefault();
      // eslint-disable-next-line no-param-reassign
      event.returnValue = 'Are you sure you want to leave?';
    },
  },
];

export const useConfirmBeforeUnload = () => {
  const { pathname } = useLocation();
  const { isAuthenticated, isAuthPending } = useAuth();
  const enteredCasesRef = useRef({});

  useEffect(() => {
    const { current: enteredCases } = enteredCasesRef;
    CASES.forEach(({
      id: caseId, entry, exit, listener,
    }) => {
      if (!enteredCases[caseId] && entry({ isAuthenticated, isAuthPending, pathname })) {
        enteredCases[caseId] = listener;
        window.addEventListener('beforeunload', listener);
      }
      if (enteredCases[caseId] && exit({ isAuthenticated, isAuthPending, pathname })) {
        window.removeEventListener('beforeunload', enteredCases[caseId]);
        enteredCases[caseId] = null;
      }
    });
  }, [isAuthenticated, isAuthPending, pathname]);

  useEffect(() => () => {
    Object.values(enteredCasesRef).forEach((listener) => {
      window.removeEventListener('beforeunload', listener);
    });
  }, []);
};
